<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app>
        <confirm ref="confirm"></confirm>
        <v-toolbar app dense   color="white" fixed>
          <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
         
          <v-spacer></v-spacer>
          

          <v-toolbar-items>
            <v-menu
              offset-y
              origin="center center"
              :nudge-bottom="10"
              transition="scale-transition"
              dense
            >
              <v-btn icon large flat slot="activator">
                <v-icon color="primary">account_circle</v-icon>
              </v-btn>
              <v-list class="pa-0">
              
                <v-list-tile
                  @click="e => {
                    console.log(e);
                  }"
                  ripple="ripple"
                  rel="noopener"
                >
                  <v-list-tile-action>
                    <v-icon  color="primary" >account_circle</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ usuario }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="logout" ripple="ripple" rel="noopener">
                  <v-list-tile-action>
                    <v-icon>power_settings_new</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Logout</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar-items>
        </v-toolbar>
        <v-navigation-drawer v-model="drawer" app fixed dark>
        <v-toolbar dense dark  color="white"  fixed>
            <router-link to="/">
            <v-responsive>
                  <div class="layout column align-center"  style="padding-right:50px;">
                    <img src="@/assets/logo.png" alt="Smartoffer OC - Sentinela"  style="width:100%;heigth:5%">
                  </div>
                </v-responsive>
             <!-- <img src="@/assets/logo.png" style="width:200px; height:30px;margin-top:5px;margin-left:3px;">-->
            </router-link>
          </v-toolbar>
          <v-list style="padding-top:70px; padding-left:10px;">
            <v-list-tile>
              <v-list-tile-avatar>                
                <v-icon large>account_circle</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ usuario }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon small>card_travel</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  <small>{{ cliente }}</small>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider/>  
           <v-list-group
            
            key="orden"
            group="orden"
            prepend-icon="add_shopping_cart"
            no-action="no-action"
            color="cyan"
          >
            <v-list-tile slot="activator" ripple="ripple">
              <v-list-tile-content>
                <v-list-tile-title>Órdenes de Compra</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!-- subgrupo -->
             <template  >
               
              <!--child item
             
                 <v-list-tile ripple="ripple" to="/home" v-if="verOC"> -->
                <v-list-tile ripple="ripple"   to="/ordencompraingreso"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>Ingreso órdenes de compra</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!--<v-list-tile ripple="ripple"   to="/ordencomprapendienteaceptada"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>Pendientes aceptar MP</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>-->
              <v-list-tile ripple="ripple"   to="/ordencompraaceptadas"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>Aceptadas</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            
              <v-list-tile ripple="ripple"   to="/ordencomprarecepcionconforme"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>Recepción Conforme</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
               <v-list-tile ripple="ripple"   to="/ordencompracanceladas"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>Canceladas</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile ripple="ripple"   to="/ordencompranoaceptada"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>No Aceptadas</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
             <v-list-tile ripple="ripple"   to="/ordencompraejecutivos"  v-if="fncIsAdmin()"> 
              <v-list-tile-content>
                <v-list-tile-title>Configuración Ejecutivos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!-- <v-list-tile ripple="ripple"   to="/ordencompramateriales"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>Mantenedor Materiales</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
             <v-list-tile ripple="ripple"   to="/ordencompraprecios"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>Mantenedor Precios</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile> -->
             <!--<v-list-tile ripple="ripple"   to="/ordencompracontratos"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>Mantenedor Contratos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>-->
            </template>
          </v-list-group>
          <v-divider/>
            <v-list-group
            
            key="reporte"
            group="reporte"
            prepend-icon="trending_up"
            no-action="no-action"
            color="cyan"
          >
            <v-list-tile slot="activator" ripple="ripple">
              <v-list-tile-content>
                <v-list-tile-title>Reportes</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!-- subgrupo -->
             <template  >
               
              <!--child item
             
                 <v-list-tile ripple="ripple" to="/home" v-if="verOC"> -->
                <v-list-tile ripple="ripple"   to="/reportehistorico"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>Reporte histórico</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile ripple="ripple"   to="/reportemensual"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>Reporte mensual</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          
            </template>
          </v-list-group>
           <v-divider/>
            <v-list-group
            
            key="convenio"
            group="convenio"
            prepend-icon="event_available"
            no-action="no-action"
            color="cyan"
          >
            <v-list-tile slot="activator" ripple="ripple">
              <v-list-tile-content>
                <v-list-tile-title>Convenio Marco</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!-- subgrupo -->
             <template  >
               
              <!--child item
             s
                 <v-list-tile ripple="ripple" to="/home" v-if="verOC"> -->
                <v-list-tile ripple="ripple"   to="/productosCM"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>Ver Productos CM</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile ripple="ripple"   to="/tendenciasCM"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>Reporte tendencias CM</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-list-tile ripple="ripple"   to="/dashboardOCCM"  v-if="verOC"> 
              <v-list-tile-content>
                <v-list-tile-title>Reporte CM - OC</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            </template>
          </v-list-group>
          </v-list>
        </v-navigation-drawer>
        <!-- CONTENIDO-->
        <v-content>
          <transition>
            <keep-alive>
              <router-view :key="$route.fullPath"></router-view>
            </keep-alive>
          </transition>
           <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
        </v-content>
        <v-footer class="pa-3" color="primary" dark>
          <v-spacer></v-spacer>
          <div>Smartoffer - Sentinela OC v1.0.0 &copy; {{ new Date().getFullYear() }}</div>
        </v-footer>
      </v-app>
    </template>
    <template v-else>
      <v-content>
        <transition>
          <keep-alive>
            <router-view :key="$route.fullPath"></router-view>
          </keep-alive>
        </transition>
         <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
      </v-content>
    </template>
   
  </div>
</template>
 
 


<script>
import Vue from 'vue'
import OrdenCompraIngreso from "./views/OrdenCompraIngreso.vue";

import VBtnMenu from "@/components/VBtnMenu";
import AppEvents from "./eventBus";
export default {
  name: "App",
  components: {
    OrdenCompraIngreso,

    VBtnMenu
  },
  data() {
    return {
      namePrueba : '',
      drawer: false,
      items: [
        {
          icon: "account_circle",
          href: "#",
          title: "Usuario Prueba",
          click: e => {
            console.log(e);
          }
        },
        {
          icon: "power_settings_new",
          href: "#",
          title: "Logout",
          click: e => {
            this.$refs.confirm
              .open("Salir", "Desea salir de la aplicación?", {
                color: "orange"
              })
              .then(confirm => {
                if (confirm) {
                  window.getApp.$emit("APP_LOGOUT");
                }
              });
          }
        }
      ],
      itemsApps: [
        {
          icon: "assessment",
          href: "#",
          title: "Licitaciones",
          click: e => {
            window.getApp.$emit("APP_LOGOUT");
          }
        }
      ],
      snackbar: {
        show: false,
        text: "",
        color: ""
      }
    };
  },
  methods: {
      uuidv4() { 

return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) { 

var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8); 

return v.toString(16); 

   }); 

} ,
     
    logout() {
      this.$refs.confirm
        .open("Salir", "Desea salir de la aplicación?", {
          color: "orange"
        })
        .then(confirm => {
          if (confirm) {
           AppEvents.$emit("APP_LOGOUT");
          }
        });
    },
    fncIsAdmin()
    {
      
        var rol = this.$store.getters.currentRol;
        
      return  (rol=="Admin" || rol=="AdminCliente");
    }
  },
  created() {
     
    AppEvents.$on('APP_LOGOUT', () => {
       localStorage.clear();
       Vue.prototype.stopSignalR();
            this.snackbar = {
                show: true,
                color: 'green',
                text: 'Logout realizado con éxito.'
            }; 
            this.$router.replace({
                path: '/login'
            });
    })
    AppEvents.$on('APP_LOGOUT_MULTIPLE', () => {
       localStorage.clear();
       Vue.prototype.stopSignalR();
            this.snackbar = {
                show: true,
                color: 'red',
                text: 'Logout realizado debido login múltiple'
            }; 
            this.$router.replace({
                path: '/login'
            });
    })
     
    window.getApp = this;
  },
  computed: {
     isAdmin(){
      debugger;
      var isAdmin = localStorage.getItem('rol');
      return (isAdmin=="Admin" || isAdmin=="AdminCliente");

    },
    verCM(){
      debugger;
      var verCM = localStorage.getItem('tieneCM');
      return (verCM=="true");

    },
     verOC(){
      debugger;
      var verOC = localStorage.getItem('tieneOC');
      return (verOC=="true");

    },
    usuario() {
      var usuario = this.$store.getters.currentUser;
      if (!usuario) {
        return "";
      } else {
        return usuario;
      }
    },
    cliente() {
      var cliente = this.$store.getters.currentCliente;
      if (!cliente) {
        return "";
      } else {
        return cliente;
      }
    }
  },
   
  
};
</script>
 